var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14H2M7 9H2M15 4H2M19.6978 17.9623L22.4193 20.6839M10.1725 13.8801C10.1725 15.3236 10.7459 16.7081 11.7667 17.7289C12.7875 18.7496 14.1719 19.3231 15.6155 19.3231C17.0591 19.3231 18.4436 18.7496 19.4643 17.7289C20.4851 16.7081 21.0586 15.3236 21.0586 13.8801C21.0586 12.4365 20.4851 11.052 19.4643 10.0312C18.4436 9.01047 17.0591 8.437 15.6155 8.437C14.1719 8.437 12.7875 9.01047 11.7667 10.0312C10.7459 11.052 10.1725 12.4365 10.1725 13.8801Z",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsole);
export default __webpack_public_path__ + "static/media/console.7ddf8e3d7824ca79e49f5499fbdef0dc.svg";
export { ForwardRef as ReactComponent };